<template>
  <v-container class="content" fluid pa-0 mt-4 fill-height>
    <the-loading ref="loading" />
    <v-layout row fill-height class="justify-center text-xs-center">
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-card flat>
          <v-card-text style="height:100%">
            <add-cc-moneris-form
              v-if="hostedTokenizationToken"
              ref="monerisForm"
              :hostedTokenizationToken="hostedTokenizationToken"
              @moneris-success="onMonerisSuccess"
              width="100%"
            />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import TheLoading from "@/components/TheLoading.vue"
import Bus from '../../bus'
import AddCcMonerisForm from "@/components/AddCCMonerisForm.vue";

export default {
    name: "VizibillMonerisForm",
    components: {
    TheLoading,
    AddCcMonerisForm,
  },
    props: {
      customer: String,
      clientToken: String,
      name: String,
      email: String,
      accountToken: String,
      vizibillAppUrl: String,
      invoiceNumber: String,
      invoiceAmount: String,
      invoices: Array,
      paymentMethod: String,
      defaultPayment: Boolean,
      userName: String,
      account: Object,
    },
    data: () => ({
        ccPerson: {
            ccName: "",
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: ""
        },
        ccAddress: {
            streetNumber: "",
            streetName: "",
            aptSuite: "",
            city: "",
            stateProv: "",
            postalZip: ""
        },
        menu: false,
        formType: "",
        boss40ApiUrl: "",
        isSameAccountInfo: false,
        hostedTokenizationToken: "",
        monerisData: {},
        previousPaymentMethodId: '',
        country: ''
    }),

    async mounted(){
      await this.getHostedTokenizationToken();
      this.previousPaymentMethodId = this.$route.query.paymentMethodId;
      this.country = this.$route.query.country;
    },

    methods: {
      async getHostedTokenizationToken() {
        await axios.post(process.env.VUE_APP_PGAPI + "api/config/gethostedtokenizationtoken", {
          clientToken: this.clientToken,
        }).then((resp) => {
          if (resp.data) {
            this.hostedTokenizationToken = resp.data.HostedTokenizationToken;
          } else {
            console.log("Error fetching hosted tokenization token:");
          }
        })
        .catch((err) => {
          console.log("Error fetching hosted tokenization token:");
          console.log(err)
        });
      },
      async submit() {
        if (this.$refs.monerisForm && this.$refs.monerisForm.doMonerisSubmit) {
          this.$refs.monerisForm.doMonerisSubmit();
          // Do not proceed until onMonerisSuccess is called
          return;
        }
        this.$refs.loading.processing(false)
      },
      onMonerisSuccess(data) {
        // Use the returned data to submit the payment
        this.monerisData = {
          payGateToken: this.clientToken,
          BAN: this.$props.customer,
          TemporaryToken: data.TemporaryToken,
          ccPerson: data.ccPerson || {},
          ccAddress: data.ccAddress || {},
          PaymentMethodId: this.previousPaymentMethodId,
          Amount: this.$props.invoiceAmount,
          Currency: 'usd',
          DefaultPayment: this.$props.defaultPayment,
        }

        this.submitWithMonerisData();
      },
      async submitWithMonerisData() {
        this.$refs.loading.processing(true)
        await axios.post(process.env.VUE_APP_PGAPI + "api/card/payment", this.monerisData)
          .then(res => {
            if (res.status == 200) {
              Bus.$emit('alert', {
                  color: 'success',
                  message: 'Payment processed successfully!'
              })
              this.$router.push({ 
                  name: 'PaymentConsole',
                  query: {
                      token: this.accountToken,
                      paymentMethodId: this.defaultPayment ? 'CC' : this.previousPaymentMethodId,
                      country: this.country
                  }
              })
            }
          })
          .catch(async (error) => {
            Bus.$emit('alert', {
              color: 'error',
              message: `There was an error processing your payment, please try again.`
            })
            
            console.log(error);
            // revert payment method change if failed
            this.account.PaymentMethodId = this.previousPaymentMethodId;
            this.account.AccountNumber =  this.$props.customer;
            await axios.post(
              process.env.VUE_APP_PGAPI + "api/boss40/updatepaymentmethod",
              { account: this.account, payGateToken: this.clientToken }
            );
          });
        this.$refs.loading.processing(false)
      },
    }
}
</script>

<style scoped>
/deep/div.v-input.v-input--selection-controls.v-input--checkbox {
  margin-top: 0px;
  padding-top: 0px;
}
</style>